import { AdditionalDataRow } from 'api/concierge';
import { AdditionalData, SearchResults } from '../types';
import { relatedReportElements } from './relatedReports';
import { docsAnswerFromColumn } from './docsAnswer';
import { settleSearchResultsWhy } from './reportWhy';

export const parseAdditionalDataColumn = <T>(value: string | null | undefined): T | null => {
    if (!value) {
        return null;
    }

    try {
        const parsed = JSON.parse(value);
        return parsed ?? null;
    } catch (error) {
        return null;
    }
};

/** The turn's additional-data row as the panel's block; null when it carries nothing to show. */
export function additionalDataBlock(row: AdditionalDataRow, currentElementId?: string): AdditionalData | null {
    const searchResults = parseAdditionalDataColumn<SearchResults>(row.search_element_result);
    const validRelatedElements = relatedReportElements(
        parseAdditionalDataColumn<unknown>(row.related_elements_result),
        currentElementId,
    );

    const block: AdditionalData = {
        data_type: 'additional_data',
        docs_answer: docsAnswerFromColumn(parseAdditionalDataColumn<unknown>(row.search_glossary_result)),
        search_results:
            Array.isArray(searchResults?.data) && searchResults.data.length
                ? settleSearchResultsWhy(searchResults)
                : null,
        related_reports: validRelatedElements.length
            ? { data_type: 'related_reports', elements: validRelatedElements }
            : null,
    };

    return block.docs_answer || block.search_results || block.related_reports ? block : null;
}
